import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import useRefreshToken from './useRefreshToken';
import useAuth from './useAuth';

const PersistLogin = () => {
    const [isLoading, setIsLoading] = useState(true);
    const refresh = useRefreshToken();
    const { auth, persist } = useAuth();
    const { pathname } = useLocation();
    const navigate = useNavigate();
    
    useEffect(() => {
        let isMounted = true;

        const verifyRefreshToken = async () => {
            try {
                await refresh();
            }
            catch (err) {
                console.error(err);
            }
            finally {
                isMounted && setIsLoading(false);
            }
        }
        // Avoids unwanted call to verifyRefreshToken
        // !auth?.accessToken && persist ? verifyRefreshToken() : setIsLoading(false);

        if (auth?.accessToken && pathname === '/login') {
            navigate('/dashboard', { replace: true }); 
        } else if (!auth?.accessToken && persist) {
            verifyRefreshToken(); 
        } else {
            setIsLoading(false); 
        }

        return () => isMounted = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            {!persist
                ? <Outlet />
                : isLoading
                    ? <p>Loading...</p>
                    : <Outlet />
            }
        </>
    )
}

export default PersistLogin